import React from 'react';
import './AboutUs.css'; // You'll need to create this CSS file

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-title">About Us</h1>
          <p className="about-subtitle">
            Your trusted partner in digital marketing excellence
          </p>
        </div>
      </section>

      <section className="about-content">
        <div className="content-wrapper">
          <div className="about-section">
            <h2>Who We Are</h2>
            <p>
              We are a dedicated team of digital marketing specialists who understand 
              that every business is unique. Our approach focuses on creating tailored 
              solutions that deliver real, measurable results for our clients.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Mission</h2>
            <p>
              To empower businesses with innovative digital marketing strategies that 
              drive growth, increase visibility, and create lasting connections with 
              their target audiences.
            </p>
          </div>

          <div className="about-section">
            <h2>What We Do</h2>
            <p>
              From comprehensive SEO strategies to engaging social media campaigns, 
              we hunt down the perfect digital marketing solutions for your business. 
              Our data-driven approach ensures every campaign delivers tangible results.
            </p>
          </div>

          <div className="stats-section">
            <div className="stat-item">
              <h3>100+</h3>
              <p>Successful Campaigns</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat-item">
              <h3>5+</h3>
              <p>Years Experience</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;